<template>
  <div>
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary">{{ importe }}</router-link>
  </div>
</template>

<script>
export default {
  name: 'CellRendererMonedaLink',
  computed: {
    url () {
      var ruta = ''
      this.params.data.tipoMovimiento === 'I' ? ruta = '/contabilidad/ingresos/ver/'  + this.params.data.id : ruta = '/contabilidad/gastos/ver/'  + this.params.data.id

      return ruta
    }, 
    importe () {
        const imp = new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(this.params.value)
        return imp
    }
  }
}
</script>